export const isElementVisible = (element: HTMLElement, offsetTop: number) => {
  if (!element) {
    return false;
  }
  const rect = element.getBoundingClientRect();
  return rect.top < offsetTop;
};
